import * as commonScripts from '../common'
import stickybits from 'stickybits'

const cmpPerspectivesDetail = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    _.printToPdfBtn = _.component.querySelector('.print-to-pdf')
    _.contactStandardBlock = document.querySelector('.cmp-contact-standard-block')
    _.formsOnSelection = document.querySelector('.forms-on-selection')

    commonScripts.util.inheritPermalink(element)
    if (commonScripts.util.detectIE()) {
      stickybits('.cmp-perspectives-detail__share--desktop')
    }

    if (_.printToPdfBtn != null) {
      _.printToPdfBtn.addEventListener('click', (e) => {
        if(_.contactStandardBlock != null){
        _.contactStandardBlock.removeAttribute("style")
        _.contactStandardBlock.previousElementSibling.classList.add("d-print-none")
          if(_.formsOnSelection != null){
            _.formsOnSelection.nextElementSibling.classList.add("d-print-none")
          }
        }
        window.print()
      })
    }
  }

}

export default cmpPerspectivesDetail
